import React from 'react'

import { Box, Divider, Grid } from '@mui/material'
import { type EditAssetHolderProps } from './EditAssetHolderForm'
import { DataGrid, type GridColDef } from '@mui/x-data-grid'
import ActivityStatementComponent from './ActivityStatementComponent'
import Chip from '@mui/material/Chip'
import CurrencyCodeChip from '../../components/chips/CurrencyCodeChip'

const EditAssetHolderFinanceDetailsView: React.FC<EditAssetHolderProps> = ({
  assetHolder
}: EditAssetHolderProps) => {
  const numberColumnFormat: GridColDef = {
    field: '',
    headerName: '',
    width: 150,
    editable: false,
    align: 'right',
    headerAlign: 'center'
  }
  const labelColumnFormat: GridColDef = {
    field: '',
    headerName: '',
    width: 150,
    editable: false
  }

  const gridColumns: GridColDef[] = [
    {
      field: 'ledgerAccountId',
      headerName: 'Wallet ID',
      flex: 15,
      editable: false
    },

    {
      ...labelColumnFormat,
      field: 'accountName',
      headerName: 'Account Name',
      flex: 30
    },
    {
      ...labelColumnFormat,
      field: 'accountType',
      headerName: 'Type',
      flex: 35,
      renderCell: params => (
          <Chip label={params.value} variant='outlined' />
      )
    },
    {
      ...labelColumnFormat,
      field: 'currencyCode',
      headerName: 'Currency',
      flex: 15,
      renderCell: params => (
          <CurrencyCodeChip code={params.value} name={params.value} />
      )
    },

    {
      ...numberColumnFormat,
      field: 'currentBalanceFormatted',
      flex: 30,
      headerName: 'Current Balance'
    },
    {
      ...numberColumnFormat,
      field: 'availableBalanceFormatted',
      flex: 30,
      headerName: 'Available Balance'
    },
    {
      ...numberColumnFormat,
      field: 'pendingWithdrawalsBalanceFormatted',
      flex: 30,
      headerName: 'Pending Withdrawals'
    },
    {
      ...numberColumnFormat,
      field: 'pendingConversionsBalanceFormatted',
      flex: 30,
      headerName: 'Pending Conversions'
    },

    {
      ...numberColumnFormat,
      field: 'totalPrefundsFormatted',
      flex: 30,
      valueGetter: (params: any) => params.row.transactionSummary?.totalPrefundsFormatted,
      headerName: 'Prefunds'
    },
    {
      ...numberColumnFormat,
      field: 'totalPurchasesFormatted',
      flex: 30,
      valueGetter: (params: any) => params.row.transactionSummary?.totalPurchasesFormatted,
      headerName: 'Purchases'
    },
    {
      ...numberColumnFormat,
      field: 'totalIncomeFormatted',
      flex: 30,
      valueGetter: (params: any) => params.row.transactionSummary?.totalIncomeFormatted,
      headerName: 'Income'
    },
    {
      ...numberColumnFormat,
      field: 'totalWithdrawalsFormatted',
      flex: 30,
      valueGetter: (params: any) => params.row.transactionSummary?.totalWithdrawalsFormatted,
      headerName: 'Withdrawals'
    }

  ]

  return (
    <>
        <Box sx={{ pb: 4 }}>
          <h3>Wallets</h3>
          <Grid container spacing={4} >
            <Grid item md={12}>
              <DataGrid
                getRowId={(row) => row.ledgerAccountId}
                rows={assetHolder.ledgerAccounts}
                columns={gridColumns}
                autoHeight={true}
                pageSize={10}
                rowsPerPageOptions={[10]}
                disableSelectionOnClick
              />
            </Grid>
          </Grid>
        </Box>

        {/* ==================================================================================================== */}

      <Divider/>
      <Box sx={{ pb: 4 }}>
        <ActivityStatementComponent assetHolder={assetHolder} />
      </Box>
    </>
  )
}

export default EditAssetHolderFinanceDetailsView
